import * as React from "react";
import * as _ from "lodash";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import { withStyles } from "@material-ui/core/styles";

type Props = {
  style?: React.CSSProperties;
  minLength?: number;
  debounceTimeout: number;
  value?: string;
  placeholder?: string;
  onChange: (
    newValue: string,
    event: React.FormEvent<HTMLInputElement>
  ) => void;
  className?: string;
  typeInput?: boolean;
};

type State = {
  value: string;
};

const StyledInput = withStyles({
  root: { margin: "10px", color: "white" },
  underline: {
    "&:before": {
      borderBottomColor: "white"
    },
    "&:after": {
      borderBottomColor: "white"
    },
    "&:hover": {
      borderBottomColor: "white"
    }
  }
})(Input);

class BODebounceInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      value: this.props.value || ""
    };

    this.change = _.debounce(this.change, this.props.debounceTimeout);
  }

  onChange = (e: any): void => {
    const value = e.target.value;
    this.setState({ value });
    if (value.length > (this.props.minLength || 0) || value.length === 0) {
      e.persist();
      this.change(value, e);
    }
  };

  change = (newValue: string, event: React.FormEvent<HTMLInputElement>): void =>
    this.props.onChange(newValue, event);

  render() {
    const {
      onChange,
      props: { placeholder, className, style, typeInput },
      state: { value }
    } = this;

    return !!typeInput ? (
      <StyledInput
        style={style}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    ) : (
      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className || ""}
        style={style}
      />
    );
  }
}

export default BODebounceInput;
